unit View.Plano_Contas_Contabil.Edit;

interface

uses
  System.SysUtils, System.Classes, WEBLib.Graphics, WEBLib.Forms, WEBLib.Dialogs,
  Vcl.Controls, Vcl.StdCtrls, WEBLib.StdCtrls,

  Bcl.Rtti.Common, XData.Web.Client, Data.DB, WEBLib.CDS,
  WEBLib.DBCtrls, XData.Web.JsonDataset, XData.Web.Dataset, JS,

  App.Types, Crud.Utils, WEBLib.DB, WEBLib.Controls, WEBLib.ExtCtrls;

type
  TFViewPlano_Contas_ContabilEdit = class(TForm)
    pnlMessage: TPanel;
    lbMessage: TLabel;
    btCloseMessage: TButton;
    DataSource: TDatasource;
    btCancel: TButton;
    btSave: TButton;
    btDelete: TButton;
    lbid: TLabel;
    edid: TDBEdit;
    lbaliado_id: TLabel;
    edaliado_id: TDBEdit;
    lbdata_base_id: TLabel;
    eddata_base_id: TDBEdit;
    lbnome: TLabel;
    ednome: TDBEdit;
    lbnivel: TLabel;
    ednivel: TDBEdit;
    lbtipo: TLabel;
    edtipo: TDBEdit;
    lbcodigo_interno: TLabel;
    edcodigo_interno: TDBEdit;
    lbexcluido: TLabel;
    edexcluido: TDBEdit;
    lbinclusao: TLabel;
    edinclusao: TDBEdit;
    lbalteracao: TLabel;
    edalteracao: TDBEdit;
    lbexclusao: TLabel;
    edexclusao: TDBEdit;
    XDataClientPlano_Contas_ContabilGet: TXDataWebClient;
    XDataClientPlano_Contas_ContabilDelete: TXDataWebClient;
    Plano_Contas_ContabilDataset: TXDataWebDataSet;
    Plano_Contas_ContabilDatasetid: TIntegerField;
    Plano_Contas_ContabilDatasetaliado_id: TIntegerField;
    Plano_Contas_ContabilDatasetdata_base_id: TIntegerField;
    Plano_Contas_ContabilDatasetnome: TStringField;
    Plano_Contas_ContabilDatasetnivel: TStringField;
    Plano_Contas_ContabilDatasettipo: TStringField;
    Plano_Contas_ContabilDatasetcodigo_interno: TIntegerField;
    Plano_Contas_ContabilDatasetexcluido: TBooleanField;
    Plano_Contas_ContabilDatasetinclusao: TDateTimeField;
    Plano_Contas_ContabilDatasetalteracao: TDateTimeField;
    Plano_Contas_ContabilDatasetexclusao: TDateTimeField;
    procedure btCloseMessageClick(Sender: TObject);
    procedure btCancelClick(Sender: TObject);
    procedure btSaveClick(Sender: TObject);
    procedure btDeleteClick(Sender: TObject);
    procedure XDataClientPlano_Contas_ContabilGetLoad(Response: TXDataClientResponse);
    procedure XDataClientPlano_Contas_ContabilDeleteLoad(Response: TXDataClientResponse);
    procedure XDataClientPlano_Contas_ContabilDeleteError(Error: TXDataClientError);
    procedure Plano_Contas_ContabilDatasetAfterApplyUpdates(Sender: TDataSet;
      Info: TResolveResults);
    procedure WebFormCreate(Sender: TObject);
  private
    FId: JSValue;
    FShowListProc: TListProc;
    procedure InsertEntity;
    procedure LoadEntity;
    procedure ShowNotification(Notification: string);
    procedure HiddenNotification;
    class function InternalCreateForm(AElementID: string;
      AShowListProc: TListProc; AInserting: Boolean; AId: JSValue): TForm; overload;
  protected
    FInserting: Boolean;
  public
    class function CreateForm(AElementID: string;
      AShowListProc: TListProc; AId: JSValue): TForm; overload;
  protected procedure LoadDFMValues; override; end;

var
  FViewPlano_Contas_ContabilEdit: TFViewPlano_Contas_ContabilEdit;

implementation

uses
  ConnectionModule;

{$R *.dfm}

{ TFViewPlano_Contas_ContabilEdit }

procedure TFViewPlano_Contas_ContabilEdit.btSaveClick(Sender: TObject);
begin
  if Plano_Contas_ContabilDataset.State in dsEditModes then
  begin
        Plano_Contas_ContabilDataset.Post;
    Plano_Contas_ContabilDataset.ApplyUpdates;
  end
  else
    FShowListProc;
end;

procedure TFViewPlano_Contas_ContabilEdit.btDeleteClick(Sender: TObject);
begin
  if Plano_Contas_ContabilDataset.State in dsEditModes then
    Plano_Contas_ContabilDataset.Post;
  XDataClientPlano_Contas_ContabilDelete.Delete(Plano_Contas_ContabilDataset.EntitySetName,
    TJSObject(Plano_Contas_ContabilDataset.CurrentData));
end;


class function TFViewPlano_Contas_ContabilEdit.CreateForm(AElementID: string;
  AShowListProc: TListProc; AId: JSValue): TForm;
var
  Inserting: Boolean;
begin
  Inserting := isNull(AId);
  Result := InternalCreateForm(AElementID, AShowListProc, Inserting, AId);
end;

procedure TFViewPlano_Contas_ContabilEdit.HiddenNotification;
begin
  pnlMessage.ElementHandle.hidden := True;
end;

procedure TFViewPlano_Contas_ContabilEdit.InsertEntity;
begin
  Plano_Contas_ContabilDataset.Close;
  Plano_Contas_ContabilDataset.SetJsonData('{}');
  Plano_Contas_ContabilDataset.Open;
  Plano_Contas_ContabilDataset.Insert;
end;

class function TFViewPlano_Contas_ContabilEdit.InternalCreateForm(AElementID: string;
  AShowListProc: TListProc; AInserting: Boolean; AId: JSValue): TForm;

  procedure AfterCreate(AForm: TObject);
  begin
    TFViewPlano_Contas_ContabilEdit(AForm).FInserting := AInserting;
    TFViewPlano_Contas_ContabilEdit(AForm).FId := AId;
    TFViewPlano_Contas_ContabilEdit(AForm).FShowListProc := AShowListProc;
    if AInserting then
      TFViewPlano_Contas_ContabilEdit(AForm).InsertEntity
    else
      TFViewPlano_Contas_ContabilEdit(AForm).LoadEntity;
    TFViewPlano_Contas_ContabilEdit(AForm).btDelete.Enabled := not AInserting;
  end;

begin
  Application.CreateForm(TFViewPlano_Contas_ContabilEdit, AElementID, Result, @AfterCreate);
end;

procedure TFViewPlano_Contas_ContabilEdit.LoadEntity;
var
  QueryString: string;
begin
  QueryString := TCrudUtils.GetEntityGetQueryString(
    Plano_Contas_ContabilDataset.Connection.Model.DefaultSchema.FindEntityType(
      Plano_Contas_ContabilDataset.EntitySetName
    )
  );
  XDataClientPlano_Contas_ContabilGet.Get(Plano_Contas_ContabilDataset.EntitySetName, QueryString, FId);
end;

procedure TFViewPlano_Contas_ContabilEdit.ShowNotification(Notification: string);
begin
  lbMessage.Caption := Notification;
  pnlMessage.ElementHandle.hidden := False;
end;

procedure TFViewPlano_Contas_ContabilEdit.btCloseMessageClick(Sender: TObject);
begin
  HiddenNotification;
end;

procedure TFViewPlano_Contas_ContabilEdit.WebFormCreate(Sender: TObject);
begin
  HiddenNotification;
end;

procedure TFViewPlano_Contas_ContabilEdit.XDataClientPlano_Contas_ContabilGetLoad(Response: TXDataClientResponse);
begin
  Plano_Contas_ContabilDataset.Close;
  Plano_Contas_ContabilDataset.SetJsonData(Response.Result);
  Plano_Contas_ContabilDataset.Open;
  
  Plano_Contas_ContabilDataset.Edit;  
end;

procedure TFViewPlano_Contas_ContabilEdit.XDataClientPlano_Contas_ContabilDeleteError(
  Error: TXDataClientError);
begin
  ShowNotification(Error.ErrorMessage);
end;

procedure TFViewPlano_Contas_ContabilEdit.XDataClientPlano_Contas_ContabilDeleteLoad(
  Response: TXDataClientResponse);
begin
  FShowListProc;
end;

procedure TFViewPlano_Contas_ContabilEdit.Plano_Contas_ContabilDatasetAfterApplyUpdates(Sender: TDataSet;
  Info: TResolveResults);
var
  I: integer;
  ResolveInfo: TResolveInfo;
begin
  for I := 0 to Length(Info.Records) - 1 do
  begin
    ResolveInfo := Info.Records[I];
//    if ResolveInfo.ResolveStatus = TResolveStatus.rsResolveFailed then
    if ResolveInfo.Error <> '' then
    begin
      ShowNotification(ResolveInfo.Error);
      Exit;
    end;
  end;
  FShowListProc;
end;

procedure TFViewPlano_Contas_ContabilEdit.btCancelClick(Sender: TObject);
begin
  FShowListProc;
end;

procedure TFViewPlano_Contas_ContabilEdit.LoadDFMValues;
begin
  inherited LoadDFMValues;

  pnlMessage := TPanel.Create('view.plano_contas_contabil.form.message');
  lbMessage := TLabel.Create('view.plano_contas_contabil.form.message.label');
  btCloseMessage := TButton.Create('view.plano_contas_contabil.form.message.button');
  btCancel := TButton.Create('view.plano_contas_contabil.form.btBack');
  btSave := TButton.Create('view.plano_contas_contabil.form.btSave');
  btDelete := TButton.Create('view.plano_contas_contabil.form.btDelete');
  lbid := TLabel.Create('view.plano_contas_contabil.form.lbid');
  edid := TDBEdit.Create('view.plano_contas_contabil.form.edid');
  lbaliado_id := TLabel.Create('view.plano_contas_contabil.form.lbaliado_id');
  edaliado_id := TDBEdit.Create('view.plano_contas_contabil.form.edaliado_id');
  lbdata_base_id := TLabel.Create('view.plano_contas_contabil.form.lbdata_base_id');
  eddata_base_id := TDBEdit.Create('view.plano_contas_contabil.form.eddata_base_id');
  lbnome := TLabel.Create('view.plano_contas_contabil.form.lbnome');
  ednome := TDBEdit.Create('view.plano_contas_contabil.form.ednome');
  lbnivel := TLabel.Create('view.plano_contas_contabil.form.lbnivel');
  ednivel := TDBEdit.Create('view.plano_contas_contabil.form.ednivel');
  lbtipo := TLabel.Create('view.plano_contas_contabil.form.lbtipo');
  edtipo := TDBEdit.Create('view.plano_contas_contabil.form.edtipo');
  lbcodigo_interno := TLabel.Create('view.plano_contas_contabil.form.lbcodigo_interno');
  edcodigo_interno := TDBEdit.Create('view.plano_contas_contabil.form.edcodigo_interno');
  lbexcluido := TLabel.Create('view.plano_contas_contabil.form.lbexcluido');
  edexcluido := TDBEdit.Create('view.plano_contas_contabil.form.edexcluido');
  lbinclusao := TLabel.Create('view.plano_contas_contabil.form.lbinclusao');
  edinclusao := TDBEdit.Create('view.plano_contas_contabil.form.edinclusao');
  lbalteracao := TLabel.Create('view.plano_contas_contabil.form.lbalteracao');
  edalteracao := TDBEdit.Create('view.plano_contas_contabil.form.edalteracao');
  lbexclusao := TLabel.Create('view.plano_contas_contabil.form.lbexclusao');
  edexclusao := TDBEdit.Create('view.plano_contas_contabil.form.edexclusao');
  DataSource := TDataSource.Create(Self);
  Plano_Contas_ContabilDataset := TXDataWebDataSet.Create(Self);
  Plano_Contas_ContabilDatasetid := TIntegerField.Create(Self);
  Plano_Contas_ContabilDatasetaliado_id := TIntegerField.Create(Self);
  Plano_Contas_ContabilDatasetdata_base_id := TIntegerField.Create(Self);
  Plano_Contas_ContabilDatasetnome := TStringField.Create(Self);
  Plano_Contas_ContabilDatasetnivel := TStringField.Create(Self);
  Plano_Contas_ContabilDatasettipo := TStringField.Create(Self);
  Plano_Contas_ContabilDatasetcodigo_interno := TIntegerField.Create(Self);
  Plano_Contas_ContabilDatasetexcluido := TBooleanField.Create(Self);
  Plano_Contas_ContabilDatasetinclusao := TDateTimeField.Create(Self);
  Plano_Contas_ContabilDatasetalteracao := TDateTimeField.Create(Self);
  Plano_Contas_ContabilDatasetexclusao := TDateTimeField.Create(Self);
  XDataClientPlano_Contas_ContabilGet := TXDataWebClient.Create(Self);
  XDataClientPlano_Contas_ContabilDelete := TXDataWebClient.Create(Self);

  pnlMessage.BeforeLoadDFMValues;
  lbMessage.BeforeLoadDFMValues;
  btCloseMessage.BeforeLoadDFMValues;
  btCancel.BeforeLoadDFMValues;
  btSave.BeforeLoadDFMValues;
  btDelete.BeforeLoadDFMValues;
  lbid.BeforeLoadDFMValues;
  edid.BeforeLoadDFMValues;
  lbaliado_id.BeforeLoadDFMValues;
  edaliado_id.BeforeLoadDFMValues;
  lbdata_base_id.BeforeLoadDFMValues;
  eddata_base_id.BeforeLoadDFMValues;
  lbnome.BeforeLoadDFMValues;
  ednome.BeforeLoadDFMValues;
  lbnivel.BeforeLoadDFMValues;
  ednivel.BeforeLoadDFMValues;
  lbtipo.BeforeLoadDFMValues;
  edtipo.BeforeLoadDFMValues;
  lbcodigo_interno.BeforeLoadDFMValues;
  edcodigo_interno.BeforeLoadDFMValues;
  lbexcluido.BeforeLoadDFMValues;
  edexcluido.BeforeLoadDFMValues;
  lbinclusao.BeforeLoadDFMValues;
  edinclusao.BeforeLoadDFMValues;
  lbalteracao.BeforeLoadDFMValues;
  edalteracao.BeforeLoadDFMValues;
  lbexclusao.BeforeLoadDFMValues;
  edexclusao.BeforeLoadDFMValues;
  DataSource.BeforeLoadDFMValues;
  Plano_Contas_ContabilDataset.BeforeLoadDFMValues;
  Plano_Contas_ContabilDatasetid.BeforeLoadDFMValues;
  Plano_Contas_ContabilDatasetaliado_id.BeforeLoadDFMValues;
  Plano_Contas_ContabilDatasetdata_base_id.BeforeLoadDFMValues;
  Plano_Contas_ContabilDatasetnome.BeforeLoadDFMValues;
  Plano_Contas_ContabilDatasetnivel.BeforeLoadDFMValues;
  Plano_Contas_ContabilDatasettipo.BeforeLoadDFMValues;
  Plano_Contas_ContabilDatasetcodigo_interno.BeforeLoadDFMValues;
  Plano_Contas_ContabilDatasetexcluido.BeforeLoadDFMValues;
  Plano_Contas_ContabilDatasetinclusao.BeforeLoadDFMValues;
  Plano_Contas_ContabilDatasetalteracao.BeforeLoadDFMValues;
  Plano_Contas_ContabilDatasetexclusao.BeforeLoadDFMValues;
  XDataClientPlano_Contas_ContabilGet.BeforeLoadDFMValues;
  XDataClientPlano_Contas_ContabilDelete.BeforeLoadDFMValues;
  try
    Name := 'FViewPlano_Contas_ContabilEdit';
    Left := 0;
    Top := 0;
    Width := 593;
    Height := 562;
    Font.Charset := DEFAULT_CHARSET;
    Font.Color := clWindowText;
    Font.Height := -11;
    Font.Name := 'Tahoma';
    Font.Style := [];
    TabOrder := 1;
    SetEvent(Self, 'OnCreate', 'WebFormCreate');
    pnlMessage.SetParentComponent(Self);
    pnlMessage.Name := 'pnlMessage';
    pnlMessage.Left := 296;
    pnlMessage.Top := 113;
    pnlMessage.Width := 273;
    pnlMessage.Height := 60;
    pnlMessage.BorderColor := clSilver;
    pnlMessage.BorderStyle := bsSingle;
    lbMessage.SetParentComponent(pnlMessage);
    lbMessage.Name := 'lbMessage';
    lbMessage.Left := 16;
    lbMessage.Top := 24;
    lbMessage.Width := 42;
    lbMessage.Height := 13;
    lbMessage.Caption := 'Message';
    lbMessage.Transparent := True;
    btCloseMessage.SetParentComponent(pnlMessage);
    btCloseMessage.Name := 'btCloseMessage';
    btCloseMessage.Left := 248;
    btCloseMessage.Top := 11;
    btCloseMessage.Width := 22;
    btCloseMessage.Height := 25;
    btCloseMessage.Caption := 'x';
    btCloseMessage.TabOrder := 0;
    SetEvent(btCloseMessage, Self, 'OnClick', 'btCloseMessageClick');
    btCancel.SetParentComponent(Self);
    btCancel.Name := 'btCancel';
    btCancel.Left := 126;
    btCancel.Top := 502;
    btCancel.Width := 96;
    btCancel.Height := 25;
    btCancel.Caption := 'Cancel';
    btCancel.TabOrder := 1;
    SetEvent(btCancel, Self, 'OnClick', 'btCancelClick');
    btSave.SetParentComponent(Self);
    btSave.Name := 'btSave';
    btSave.Left := 24;
    btSave.Top := 502;
    btSave.Width := 96;
    btSave.Height := 25;
    btSave.Caption := 'Save';
    btSave.TabOrder := 4;
    SetEvent(btSave, Self, 'OnClick', 'btSaveClick');
    btDelete.SetParentComponent(Self);
    btDelete.Name := 'btDelete';
    btDelete.Left := 305;
    btDelete.Top := 502;
    btDelete.Width := 96;
    btDelete.Height := 25;
    btDelete.Caption := 'Delete';
    btDelete.TabOrder := 5;
    SetEvent(btDelete, Self, 'OnClick', 'btDeleteClick');
    lbid.SetParentComponent(Self);
    lbid.Name := 'lbid';
    lbid.Left := 24;
    lbid.Top := 192;
    lbid.Width := 14;
    lbid.Height := 13;
    lbid.Caption := 'id:';
    lbid.Transparent := True;
    edid.SetParentComponent(Self);
    edid.Name := 'edid';
    edid.Left := 221;
    edid.Top := 189;
    edid.Width := 200;
    edid.Height := 21;
    edid.Enabled := True;
    edid.TabOrder := 6;
    edid.Text := 'edid';
    edid.DataField := 'id';
    edid.DataSource := DataSource;
    lbaliado_id.SetParentComponent(Self);
    lbaliado_id.Name := 'lbaliado_id';
    lbaliado_id.Left := 24;
    lbaliado_id.Top := 219;
    lbaliado_id.Width := 14;
    lbaliado_id.Height := 13;
    lbaliado_id.Caption := 'aliado_id:';
    lbaliado_id.Transparent := True;
    edaliado_id.SetParentComponent(Self);
    edaliado_id.Name := 'edaliado_id';
    edaliado_id.Left := 221;
    edaliado_id.Top := 216;
    edaliado_id.Width := 200;
    edaliado_id.Height := 21;
    edaliado_id.Enabled := True;
    edaliado_id.TabOrder := 7;
    edaliado_id.Text := 'edaliado_id';
    edaliado_id.DataField := 'aliado_id';
    edaliado_id.DataSource := DataSource;
    lbdata_base_id.SetParentComponent(Self);
    lbdata_base_id.Name := 'lbdata_base_id';
    lbdata_base_id.Left := 24;
    lbdata_base_id.Top := 246;
    lbdata_base_id.Width := 14;
    lbdata_base_id.Height := 13;
    lbdata_base_id.Caption := 'data_base_id:';
    lbdata_base_id.Transparent := True;
    eddata_base_id.SetParentComponent(Self);
    eddata_base_id.Name := 'eddata_base_id';
    eddata_base_id.Left := 221;
    eddata_base_id.Top := 243;
    eddata_base_id.Width := 200;
    eddata_base_id.Height := 21;
    eddata_base_id.Enabled := True;
    eddata_base_id.TabOrder := 8;
    eddata_base_id.Text := 'eddata_base_id';
    eddata_base_id.DataField := 'data_base_id';
    eddata_base_id.DataSource := DataSource;
    lbnome.SetParentComponent(Self);
    lbnome.Name := 'lbnome';
    lbnome.Left := 24;
    lbnome.Top := 273;
    lbnome.Width := 14;
    lbnome.Height := 13;
    lbnome.Caption := 'nome:';
    lbnome.Transparent := True;
    ednome.SetParentComponent(Self);
    ednome.Name := 'ednome';
    ednome.Left := 221;
    ednome.Top := 270;
    ednome.Width := 200;
    ednome.Height := 21;
    ednome.Enabled := True;
    ednome.TabOrder := 9;
    ednome.Text := 'ednome';
    ednome.DataField := 'nome';
    ednome.DataSource := DataSource;
    lbnivel.SetParentComponent(Self);
    lbnivel.Name := 'lbnivel';
    lbnivel.Left := 24;
    lbnivel.Top := 300;
    lbnivel.Width := 14;
    lbnivel.Height := 13;
    lbnivel.Caption := 'nivel:';
    lbnivel.Transparent := True;
    ednivel.SetParentComponent(Self);
    ednivel.Name := 'ednivel';
    ednivel.Left := 221;
    ednivel.Top := 297;
    ednivel.Width := 200;
    ednivel.Height := 21;
    ednivel.Enabled := True;
    ednivel.TabOrder := 10;
    ednivel.Text := 'ednivel';
    ednivel.DataField := 'nivel';
    ednivel.DataSource := DataSource;
    lbtipo.SetParentComponent(Self);
    lbtipo.Name := 'lbtipo';
    lbtipo.Left := 24;
    lbtipo.Top := 327;
    lbtipo.Width := 14;
    lbtipo.Height := 13;
    lbtipo.Caption := 'tipo:';
    lbtipo.Transparent := True;
    edtipo.SetParentComponent(Self);
    edtipo.Name := 'edtipo';
    edtipo.Left := 221;
    edtipo.Top := 324;
    edtipo.Width := 200;
    edtipo.Height := 21;
    edtipo.Enabled := True;
    edtipo.TabOrder := 11;
    edtipo.Text := 'edtipo';
    edtipo.DataField := 'tipo';
    edtipo.DataSource := DataSource;
    lbcodigo_interno.SetParentComponent(Self);
    lbcodigo_interno.Name := 'lbcodigo_interno';
    lbcodigo_interno.Left := 24;
    lbcodigo_interno.Top := 354;
    lbcodigo_interno.Width := 14;
    lbcodigo_interno.Height := 13;
    lbcodigo_interno.Caption := 'codigo_interno:';
    lbcodigo_interno.Transparent := True;
    edcodigo_interno.SetParentComponent(Self);
    edcodigo_interno.Name := 'edcodigo_interno';
    edcodigo_interno.Left := 221;
    edcodigo_interno.Top := 351;
    edcodigo_interno.Width := 200;
    edcodigo_interno.Height := 21;
    edcodigo_interno.Enabled := True;
    edcodigo_interno.TabOrder := 12;
    edcodigo_interno.Text := 'edcodigo_interno';
    edcodigo_interno.DataField := 'codigo_interno';
    edcodigo_interno.DataSource := DataSource;
    lbexcluido.SetParentComponent(Self);
    lbexcluido.Name := 'lbexcluido';
    lbexcluido.Left := 24;
    lbexcluido.Top := 381;
    lbexcluido.Width := 14;
    lbexcluido.Height := 13;
    lbexcluido.Caption := 'excluido:';
    lbexcluido.Transparent := True;
    edexcluido.SetParentComponent(Self);
    edexcluido.Name := 'edexcluido';
    edexcluido.Left := 221;
    edexcluido.Top := 378;
    edexcluido.Width := 200;
    edexcluido.Height := 21;
    edexcluido.Enabled := True;
    edexcluido.TabOrder := 13;
    edexcluido.Text := 'edexcluido';
    edexcluido.DataField := 'excluido';
    edexcluido.DataSource := DataSource;
    lbinclusao.SetParentComponent(Self);
    lbinclusao.Name := 'lbinclusao';
    lbinclusao.Left := 24;
    lbinclusao.Top := 408;
    lbinclusao.Width := 14;
    lbinclusao.Height := 13;
    lbinclusao.Caption := 'inclusao:';
    lbinclusao.Transparent := True;
    edinclusao.SetParentComponent(Self);
    edinclusao.Name := 'edinclusao';
    edinclusao.Left := 221;
    edinclusao.Top := 405;
    edinclusao.Width := 200;
    edinclusao.Height := 21;
    edinclusao.Enabled := True;
    edinclusao.TabOrder := 14;
    edinclusao.Text := 'edinclusao';
    edinclusao.DataField := 'inclusao';
    edinclusao.DataSource := DataSource;
    lbalteracao.SetParentComponent(Self);
    lbalteracao.Name := 'lbalteracao';
    lbalteracao.Left := 24;
    lbalteracao.Top := 435;
    lbalteracao.Width := 14;
    lbalteracao.Height := 13;
    lbalteracao.Caption := 'alteracao:';
    lbalteracao.Transparent := True;
    edalteracao.SetParentComponent(Self);
    edalteracao.Name := 'edalteracao';
    edalteracao.Left := 221;
    edalteracao.Top := 432;
    edalteracao.Width := 200;
    edalteracao.Height := 21;
    edalteracao.Enabled := True;
    edalteracao.TabOrder := 15;
    edalteracao.Text := 'edalteracao';
    edalteracao.DataField := 'alteracao';
    edalteracao.DataSource := DataSource;
    lbexclusao.SetParentComponent(Self);
    lbexclusao.Name := 'lbexclusao';
    lbexclusao.Left := 24;
    lbexclusao.Top := 462;
    lbexclusao.Width := 14;
    lbexclusao.Height := 13;
    lbexclusao.Caption := 'exclusao:';
    lbexclusao.Transparent := True;
    edexclusao.SetParentComponent(Self);
    edexclusao.Name := 'edexclusao';
    edexclusao.Left := 221;
    edexclusao.Top := 459;
    edexclusao.Width := 200;
    edexclusao.Height := 21;
    edexclusao.Enabled := True;
    edexclusao.TabOrder := 16;
    edexclusao.Text := 'edexclusao';
    edexclusao.DataField := 'exclusao';
    edexclusao.DataSource := DataSource;
    DataSource.SetParentComponent(Self);
    DataSource.Name := 'DataSource';
    DataSource.DataSet := Plano_Contas_ContabilDataset;
    DataSource.Left := 176;
    DataSource.Top := 56;
    Plano_Contas_ContabilDataset.SetParentComponent(Self);
    Plano_Contas_ContabilDataset.Name := 'Plano_Contas_ContabilDataset';
    Plano_Contas_ContabilDataset.AfterApplyUpdates := Plano_Contas_ContabilDatasetAfterApplyUpdates;
    Plano_Contas_ContabilDataset.EntitySetName := 'Plano_Contas_Contabil';
    Plano_Contas_ContabilDataset.Connection := DMConnection.ApiConnection;
    Plano_Contas_ContabilDataset.Left := 176;
    Plano_Contas_ContabilDataset.Top := 8;
    Plano_Contas_ContabilDatasetid.SetParentComponent(Plano_Contas_ContabilDataset);
    Plano_Contas_ContabilDatasetid.Name := 'Plano_Contas_ContabilDatasetid';
    Plano_Contas_ContabilDatasetid.FieldName := 'id';
    Plano_Contas_ContabilDatasetid.Required := True;
    Plano_Contas_ContabilDatasetaliado_id.SetParentComponent(Plano_Contas_ContabilDataset);
    Plano_Contas_ContabilDatasetaliado_id.Name := 'Plano_Contas_ContabilDatasetaliado_id';
    Plano_Contas_ContabilDatasetaliado_id.FieldName := 'aliado_id';
    Plano_Contas_ContabilDatasetaliado_id.Required := True;
    Plano_Contas_ContabilDatasetdata_base_id.SetParentComponent(Plano_Contas_ContabilDataset);
    Plano_Contas_ContabilDatasetdata_base_id.Name := 'Plano_Contas_ContabilDatasetdata_base_id';
    Plano_Contas_ContabilDatasetdata_base_id.FieldName := 'data_base_id';
    Plano_Contas_ContabilDatasetdata_base_id.Required := True;
    Plano_Contas_ContabilDatasetnome.SetParentComponent(Plano_Contas_ContabilDataset);
    Plano_Contas_ContabilDatasetnome.Name := 'Plano_Contas_ContabilDatasetnome';
    Plano_Contas_ContabilDatasetnome.FieldName := 'nome';
    Plano_Contas_ContabilDatasetnome.Required := True;
    Plano_Contas_ContabilDatasetnome.Size := 255;
    Plano_Contas_ContabilDatasetnivel.SetParentComponent(Plano_Contas_ContabilDataset);
    Plano_Contas_ContabilDatasetnivel.Name := 'Plano_Contas_ContabilDatasetnivel';
    Plano_Contas_ContabilDatasetnivel.FieldName := 'nivel';
    Plano_Contas_ContabilDatasetnivel.Required := True;
    Plano_Contas_ContabilDatasetnivel.Size := 255;
    Plano_Contas_ContabilDatasettipo.SetParentComponent(Plano_Contas_ContabilDataset);
    Plano_Contas_ContabilDatasettipo.Name := 'Plano_Contas_ContabilDatasettipo';
    Plano_Contas_ContabilDatasettipo.FieldName := 'tipo';
    Plano_Contas_ContabilDatasettipo.Required := True;
    Plano_Contas_ContabilDatasettipo.Size := 255;
    Plano_Contas_ContabilDatasetcodigo_interno.SetParentComponent(Plano_Contas_ContabilDataset);
    Plano_Contas_ContabilDatasetcodigo_interno.Name := 'Plano_Contas_ContabilDatasetcodigo_interno';
    Plano_Contas_ContabilDatasetcodigo_interno.FieldName := 'codigo_interno';
    Plano_Contas_ContabilDatasetcodigo_interno.Required := True;
    Plano_Contas_ContabilDatasetexcluido.SetParentComponent(Plano_Contas_ContabilDataset);
    Plano_Contas_ContabilDatasetexcluido.Name := 'Plano_Contas_ContabilDatasetexcluido';
    Plano_Contas_ContabilDatasetexcluido.FieldName := 'excluido';
    Plano_Contas_ContabilDatasetexcluido.Required := False;
    Plano_Contas_ContabilDatasetinclusao.SetParentComponent(Plano_Contas_ContabilDataset);
    Plano_Contas_ContabilDatasetinclusao.Name := 'Plano_Contas_ContabilDatasetinclusao';
    Plano_Contas_ContabilDatasetinclusao.FieldName := 'inclusao';
    Plano_Contas_ContabilDatasetinclusao.Required := False;
    Plano_Contas_ContabilDatasetalteracao.SetParentComponent(Plano_Contas_ContabilDataset);
    Plano_Contas_ContabilDatasetalteracao.Name := 'Plano_Contas_ContabilDatasetalteracao';
    Plano_Contas_ContabilDatasetalteracao.FieldName := 'alteracao';
    Plano_Contas_ContabilDatasetalteracao.Required := False;
    Plano_Contas_ContabilDatasetexclusao.SetParentComponent(Plano_Contas_ContabilDataset);
    Plano_Contas_ContabilDatasetexclusao.Name := 'Plano_Contas_ContabilDatasetexclusao';
    Plano_Contas_ContabilDatasetexclusao.FieldName := 'exclusao';
    Plano_Contas_ContabilDatasetexclusao.Required := False;
    XDataClientPlano_Contas_ContabilGet.SetParentComponent(Self);
    XDataClientPlano_Contas_ContabilGet.Name := 'XDataClientPlano_Contas_ContabilGet';
    XDataClientPlano_Contas_ContabilGet.Connection := DMConnection.ApiConnection;
    SetEvent(XDataClientPlano_Contas_ContabilGet, Self, 'OnLoad', 'XDataClientPlano_Contas_ContabilGetLoad');
    XDataClientPlano_Contas_ContabilGet.Left := 64;
    XDataClientPlano_Contas_ContabilGet.Top := 8;
    XDataClientPlano_Contas_ContabilDelete.SetParentComponent(Self);
    XDataClientPlano_Contas_ContabilDelete.Name := 'XDataClientPlano_Contas_ContabilDelete';
    XDataClientPlano_Contas_ContabilDelete.Connection := DMConnection.ApiConnection;
    SetEvent(XDataClientPlano_Contas_ContabilDelete, Self, 'OnLoad', 'XDataClientPlano_Contas_ContabilDeleteLoad');
    SetEvent(XDataClientPlano_Contas_ContabilDelete, Self, 'OnError', 'XDataClientPlano_Contas_ContabilDeleteError');
    XDataClientPlano_Contas_ContabilDelete.Left := 64;
    XDataClientPlano_Contas_ContabilDelete.Top := 56;
  finally
    pnlMessage.AfterLoadDFMValues;
    lbMessage.AfterLoadDFMValues;
    btCloseMessage.AfterLoadDFMValues;
    btCancel.AfterLoadDFMValues;
    btSave.AfterLoadDFMValues;
    btDelete.AfterLoadDFMValues;
    lbid.AfterLoadDFMValues;
    edid.AfterLoadDFMValues;
    lbaliado_id.AfterLoadDFMValues;
    edaliado_id.AfterLoadDFMValues;
    lbdata_base_id.AfterLoadDFMValues;
    eddata_base_id.AfterLoadDFMValues;
    lbnome.AfterLoadDFMValues;
    ednome.AfterLoadDFMValues;
    lbnivel.AfterLoadDFMValues;
    ednivel.AfterLoadDFMValues;
    lbtipo.AfterLoadDFMValues;
    edtipo.AfterLoadDFMValues;
    lbcodigo_interno.AfterLoadDFMValues;
    edcodigo_interno.AfterLoadDFMValues;
    lbexcluido.AfterLoadDFMValues;
    edexcluido.AfterLoadDFMValues;
    lbinclusao.AfterLoadDFMValues;
    edinclusao.AfterLoadDFMValues;
    lbalteracao.AfterLoadDFMValues;
    edalteracao.AfterLoadDFMValues;
    lbexclusao.AfterLoadDFMValues;
    edexclusao.AfterLoadDFMValues;
    DataSource.AfterLoadDFMValues;
    Plano_Contas_ContabilDataset.AfterLoadDFMValues;
    Plano_Contas_ContabilDatasetid.AfterLoadDFMValues;
    Plano_Contas_ContabilDatasetaliado_id.AfterLoadDFMValues;
    Plano_Contas_ContabilDatasetdata_base_id.AfterLoadDFMValues;
    Plano_Contas_ContabilDatasetnome.AfterLoadDFMValues;
    Plano_Contas_ContabilDatasetnivel.AfterLoadDFMValues;
    Plano_Contas_ContabilDatasettipo.AfterLoadDFMValues;
    Plano_Contas_ContabilDatasetcodigo_interno.AfterLoadDFMValues;
    Plano_Contas_ContabilDatasetexcluido.AfterLoadDFMValues;
    Plano_Contas_ContabilDatasetinclusao.AfterLoadDFMValues;
    Plano_Contas_ContabilDatasetalteracao.AfterLoadDFMValues;
    Plano_Contas_ContabilDatasetexclusao.AfterLoadDFMValues;
    XDataClientPlano_Contas_ContabilGet.AfterLoadDFMValues;
    XDataClientPlano_Contas_ContabilDelete.AfterLoadDFMValues;
  end;
end;

end.
